var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgS4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.55556 7C0.680556 7 0 7.72917 0 8.55555V13.2222C0 14.0972 0.680556 14.7778 1.55556 14.7778C2.09028 14.7778 2.52778 14.4861 2.81944 14.0486L8.02083 15.6528C7.875 16.0903 7.77778 16.625 7.77778 17.1111C7.77778 19.6875 9.86806 21.7778 12.4444 21.7778C14.5833 21.7778 16.3819 20.3194 16.9167 18.3264L23.3333 20.2222V1.55556L2.81944 7.77778C2.52778 7.34028 2.09028 7 1.55556 7ZM10.2569 16.2847L14.6806 17.6458C14.4375 18.6667 13.5139 19.4444 12.4444 19.4444C11.1319 19.4444 10.1111 18.4236 10.1111 17.1111C10.1111 16.8194 10.1597 16.5764 10.2569 16.2847ZM27.2222 0H25.6667C25.2292 0 24.8889 0.388889 24.8889 0.777778V21C24.8889 21.4375 25.2292 21.7778 25.6667 21.7778H27.2222C27.6111 21.7778 28 21.4375 28 21V0.777778C28 0.388889 27.6111 0 27.2222 0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS4);
export default __webpack_public_path__ + "static/media/s4.56769316cee3e05d24e07dcd61685996.svg";
export { ForwardRef as ReactComponent };